import styled from 'styled-components';

export const CustomSvg = styled.svg`
  transform: ${({ $upDirection }) =>
    $upDirection ? 'rotate(-180deg) translate(0, -20%)' : 'none'};
  transition: transform 150ms ease-in-out;
`;
